import React from 'react';
import Layout from '../components/Layout';

function Tags() {
  // 标签数据
  const tags = [
    { name: 'NLP', count: 5 },
    { name: 'Machine Learning', count: 3 },
    { name: 'Portuguese', count: 8 },
    { name: 'Linguistics', count: 4 },
    { name: 'React', count: 2 },
    // 可以添加更多标签
  ];

  return (
    <Layout>
      <div className="max-w-2xl mx-auto">
        <h2 className="text-xl font-semibold mb-4">Tags</h2>
        <div className="flex flex-wrap gap-2">
          {tags.map((tag, index) => (
            <div key={index} className="bg-gray-50 px-3 py-2 rounded-lg flex items-center">
              <span className="mr-2">{tag.name}</span>
              <span className="bg-gray-200 text-xs px-2 py-1 rounded-full">
                {tag.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export default Tags;